import Favo from 'assets/icons/favo';
import PropTypes from 'prop-types';
import { Component } from 'react';

import {
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
  PROJECT_STATUS_REJEITADO,
} from '../../library/ProjectStatus';
import styles from './StatusIcon.scss';
const rootClassName = styles.rootClassName;

class StatusIcon extends Component {
  getStatusImage() {
    switch (this.props.status) {
      case PROJECT_STATUS_PENDENTE:
        // Laranja
        return <Favo color='#FAA56E' />;
      case PROJECT_STATUS_APROVADO:
        // Verde
        return <Favo color='#9FDC8C' />;
      case PROJECT_STATUS_REJEITADO:
        // Vermelho
        return <Favo color='#F58C96' />;
      case PROJECT_STATUS_RASCUNHO:
      default:
        // Amarelo
        return <Favo color='#F3C709' />;
    }
  }

  render() {
    const allProps = {
      className: this.props.className
        ? rootClassName + ' ' + this.props.className
        : rootClassName,
    };
    return <div {...allProps}>{this.getStatusImage()}</div>;
  }
}

StatusIcon.propTypes = {
  status: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default StatusIcon;
